import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import { Card, CardBody } from "./../../components/card/card.jsx";
import { CardHeader } from "react-bootstrap";
import { useState } from "react";
import { questDataDificulty } from "../../config/apiSPA.js";
const dataInit = {
  mc: [],
  tf: [],
  match: [],
};
function ModalQuestionResumeDif({ show, onHide, id, title, textStyle, diffculty = "dificult" }) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(dataInit);
  function onShow() {
    setLoading(true);
    questDataDificulty(`${id}?prePost=post&mode=${diffculty}`).then((res) => {
      setLoading(false);
      setData(res.data);
    });
  }

  return (
    <>
      <Modal show={show} onHide={onHide} onShow={onShow} size="lg">
        <ModalHeader closeButton>
          <h5 className="modal-title">{title}</h5>
        </ModalHeader>
        <ModalBody>
          <p>This data base on post test event</p>
          {loading ? (
            <p>Loading.....!</p>
          ) : (
            <>
              <MultipleChoice textStyle={textStyle} data={data.mc} />
              <TrueFalse textStyle={textStyle} data={data.tf} />
              <Matching textStyle={textStyle} data={data.match} />
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <button type="button" className="btn btn-outline-theme">
            Close
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ModalQuestionResumeDif;

function MultipleChoice({ data, textStyle }) {
  return (
    <>
      <Card className="mb-4">
        <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">Multiple Choice</CardHeader>
        <CardBody>
          <div className="list-group list-group-flush">
            {data.length > 0 ? (
              data.map((val, index) => (
                <div key={index} className="list-group-item d-flex px-3">
                  <div className="me-3">
                    <div className="fw-400">{index + 1}.</div>
                  </div>
                  {/* ----------------------------------------------------------------------------------------------------- */}
                  <div className="flex-fill">
                    <div className="fw-400 mb-1">
                      {val.soal}
                      <span className={textStyle}>{`(${val.rate}% / ${val.res} resp.)`}</span>
                    </div>

                    {/* {soal.img ? (
                      <div className="mb-3">
                        <ImageHandler url={soal.img} />
                      </div>
                    ) : (
                      ""
                    )} */}
                  </div>
                </div>
              ))
            ) : (
              <p>No data</p>
            )}
          </div>
        </CardBody>
      </Card>
    </>
  );
}

function TrueFalse({ data, textStyle }) {
  return (
    <>
      <Card className="mb-4">
        <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">True False</CardHeader>
        <CardBody>
          <div className="list-group list-group-flush">
            {data.length > 0 ? (
              data.map((val, index) => (
                <div key={index} className="list-group-item d-flex px-3">
                  <div className="me-3">
                    <div className="fw-400">{index + 1}.</div>
                  </div>
                  {/* ----------------------------------------------------------------------------------------------------- */}
                  <div className="flex-fill">
                    <div className="fw-400 mb-1">
                      {val.soal}
                      <span className={textStyle}>{`(${val.rate}% / ${val.res} resp.)`}</span>
                    </div>

                    {/* {soal.img ? (
                      <div className="mb-3">
                        <ImageHandler url={soal.img} />
                      </div>
                    ) : (
                      ""
                    )} */}
                  </div>
                </div>
              ))
            ) : (
              <p>No data</p>
            )}
          </div>
        </CardBody>
      </Card>
    </>
  );
}

function Matching({ data, textStyle }) {
  return (
    <>
      <Card className="mb-4">
        <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">Matching</CardHeader>
        <CardBody>
          <div className="list-group list-group-flush">
            {data.length > 0 ? (
              data.map((val, index) => (
                <div key={index} className="list-group-item d-flex px-3">
                  <div className="me-3">
                    <div className="fw-400">{index + 1}.</div>
                  </div>
                  {/* ----------------------------------------------------------------------------------------------------- */}
                  <div className="flex-fill">
                    <div className="fw-400 mb-1">
                      {val.soal}
                      <span className={textStyle}>{`(${val.rate}% / ${val.res} resp.)`}</span>
                    </div>

                    {/* {soal.img ? (
                      <div className="mb-3">
                        <ImageHandler url={soal.img} />
                      </div>
                    ) : (
                      ""
                    )} */}
                  </div>
                </div>
              ))
            ) : (
              <p>No data</p>
            )}
          </div>
        </CardBody>
      </Card>
    </>
  );
}
